// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ysbd","newExpiryDate":"styles_newExpiryDate__x9mPN","footer":"styles_footer__2UeYT"};